<template>
  <div class="flex flex-col justify-between text-center">
    <div class="w-full bg-beige-academy-300 text-white flex items-center
    tracking-widest uppercase py-6 text-xl mb-8 relative justify-end">
      <h1 class="absolute text-center w-full">{{$t('editingSlots.edit')}}</h1>
      <button @click.prevent="$modal.hide('event-edit-modal')" class="px-4 z-20">
        <close-icon />
      </button>
    </div>
    <div class="w-3/4 mx-auto flex flex-col justify-between text-lg mb-8 font-sans-serif
    text-center">
      <div class="mb-2">
        <strong>
          <input type="date" class="border border-grey-academy-150 rounded-md p-1"
            v-model="editedSlot.day">
        </strong>
      </div>
      <div class="mb-2">
        {{$t('bookingSlots.from')}}
          <strong class="mr-4">
            <input type="time" v-model="editedSlot.start"
              class="border border-grey-academy-150 rounded-md p-1">
          </strong>
        {{$t('bookingSlots.to')}}
          <strong>
            <input type="time" v-model="editedSlot.end"
              class="border border-grey-academy-150 rounded-md p-1">
          </strong>
      </div>
      <div class="flex flex-row justify-between mt-6 text-sm w-2/3 mx-auto">
        <modal-button @click="$modal.hide('event-edit-modal')"
        :buttonPlaceholder="$t('bookingSlots.cancel')"
        buttonClass="uppercase" />
        <modal-button @click="saveEditedSlot(editedSlot, id)"
        :buttonPlaceholder="$t('editingSlots.save')"
        buttonClass="uppercase" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import DatesConversion from '@/mixins/DatesConversion';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import ModalButton from '../graphics/ModalButton.vue';
import CloseIcon from '../graphics/CloseIcon.vue';

export default {
  props: ['id', 'slotToEdit', 'savedSlots'],

  components: {
    ModalButton,
    CloseIcon,
  },

  data() {
    return {
      editedSlot: this.slotToEdit,
    };
  },

  mixins: [DatesConversion],

  computed: {
    ...mapGetters({
      choosenTimezone: 'timezone/choosenTimezone',
    }),
  },

  methods: {
    getDate(day, time) {
      const tzDate = dayjs.tz(`${day}T${time}`, this.choosenTimezone);
      return this.changeDateFormatForCalendarAndDatabase(
        this.convertDateTimezoneForDatabase(tzDate),
      );
    },

    convertSlotForDatabase(slotToConvert, id) {
      const editedSlotToSave = {
        id,
        start_date: this.getDate(slotToConvert.day, slotToConvert.start),
        end_date: this.getDate(slotToConvert.day, slotToConvert.end),
        duration: 0,
      };
      const start = dayjs(editedSlotToSave.start_date);
      const end = dayjs(editedSlotToSave.end_date);
      editedSlotToSave.duration = end.diff(start, 'minutes');

      return editedSlotToSave;
    },

    saveEditedSlot(slot, id) {
      const editedSlotToSave = this.convertSlotForDatabase(slot, id);

      if (this.checkSlot(editedSlotToSave, this.savedSlots)) {
        axios.put(`/api/slots/${id}`, editedSlotToSave).then(() => {
          this.$modal.hide('event-edit-modal');
          this.$emit('updated');
          this.createNotification('success', this.$t('editingSlots.success'));
        }).catch(() => {
          this.createNotification('error', this.$t('notifications.errorTryAgain'));
        });
        return;
      }
      this.createNotification('warning', this.$t('editingSlots.warning'));
    },
  },
};
</script>
